import "../../../../../../src/style/block.scss";
import "./style.scss";
import "../../../../../../src/style/buttons.scss";
import React from "react";
import { Assort } from "../../../../models/Assort";
import { MdCheckBox, MdOutlineCheckBoxOutlineBlank } from "react-icons/md";
import EAButton from "../../../shared/Buttons/EAButton";
import getId from "../../../../../utils/getId";

interface IProps {
  title: string;
  data: Assort[];
  selectedValue?: Assort;
  onSelect: (value: Assort) => void;
}
const SortModal: React.FC<IProps> = ({ title, data, selectedValue, onSelect }) => {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <>
      <p>{title}</p>
      <div className="SortModal">
        {data.map((item, index) => {
          const isSelected = selectedValue && getId(item) === getId(selectedValue);
          return (
            <EAButton
              key={index}
              onClick={() => onSelect(item)}
              title={item.name}
              startIcon={isSelected ? <MdCheckBox /> : <MdOutlineCheckBoxOutlineBlank />}
              variant="text"
              noMargins
            />
          );
        })}
      </div>
    </>
  );
};

export default SortModal;
